/** The document links: at the foot of each document, and in the help panel. */

import { Link } from '@tanstack/solid-router';
import { type Component, Show } from 'solid-js';
import styles from './Legal.module.css';
import { type LegalDoc, PATHS } from './meta.ts';

export interface LegalLinksProps {
  /** The document being read, which does not link to itself. */
  omit?: LegalDoc;
  /** Offer the way back to the deck — the documents are their own pages. */
  home?: boolean;
}

export const LegalLinks: Component<LegalLinksProps> = (props) => (
  <div class={styles.links} data-testid="legal-links">
    <Show when={props.home}>
      <Link to="/">The deck</Link>
    </Show>
    <Show when={props.omit !== 'privacy'}>
      <Link to={PATHS.privacy}>Privacy Policy</Link>
    </Show>
    <Show when={props.omit !== 'terms'}>
      <Link to={PATHS.terms}>Terms of Service</Link>
    </Show>
  </div>
);
